export interface Module {
  title: string
  body: string
  tagline: string
  /** Spine color of the matching book in the box-set mockup */
  color: string
}

export const modules: Module[] = [
  {
    title: 'MODULE 1 — ANATOMIE RADIOLOGIQUE & REPÈRES VISUELS',
    body: 'Tête, cou, thorax, abdomen, pelvis et membres : identifier chaque structure en radiographie, en scanner et en IRM, dans les plans axial, coronal et sagittal. Atlas comparatif de l’anatomie normale, fiches d’identification et exercices.',
    tagline: 'Reconnaître ce que l’on regarde, dans chaque modalité.',
    color: 'rgb(var(--color-module-1))',
  },
  {
    title: 'MODULE 2 — TECHNIQUES D’IMAGERIE MÉDICALE & PARAMÈTRES D’ACQUISITION',
    body: 'Radiographie conventionnelle et numérique, scanner (TDM), IRM, échographie et Doppler : comment l’image est obtenue, qualité d’image, artefacts et limites de chaque technique, avec des fiches comparatives des modalités.',
    tagline: 'Comprendre comment naît l’image.',
    color: 'rgb(var(--color-module-2))',
  },
  {
    title: 'MODULE 3 — SÉMIOLOGIE RADIOLOGIQUE & RECONNAISSANCE DES ANOMALIES',
    body: 'Une méthode de lecture systématique ; densités, signaux, contrastes et patterns ; aspects fréquents en thorax, abdomen, ostéo-articulaire et neuro-imagerie ; comparaisons normal / pathologique, erreurs d’interprétation et signaux d’alerte.',
    tagline: 'Décrire avec la bonne terminologie.',
    color: 'rgb(var(--color-module-3))',
  },
  {
    title: 'MODULE 4 — PROTOCOLES D’EXAMEN, POSITIONNEMENT & RADIOPROTECTION',
    body: 'Préparation et vérifications avant l’examen, positionnement par région anatomique, protocoles habituels de radiographie, TDM et IRM, sécurité en IRM, justification et optimisation de la dose. Check-lists et fiches opérationnelles.',
    tagline: 'Des procédures claires, examen après examen.',
    color: 'rgb(var(--color-module-4))',
  },
  {
    title: 'MODULE 5 — CAS CLINIQUES ILLUSTRÉS & ANALYSE RADIOLOGIQUE',
    body: 'Traumatologie et fractures, pathologies thoraciques fréquentes, cas abdominaux et neurologiques : analyse guidée sur illustrations pédagogiques, comparaison des diagnostics différentiels et exercices aux corrigés expliqués.',
    tagline: 'Relier l’image à la situation clinique.',
    color: 'rgb(var(--color-module-5))',
  },
  {
    title: 'MODULE 6 — WORKFLOWS CLINIQUES, CHECK-LISTS & OUTILS PRATIQUES',
    body: 'Le circuit complet de l’examen : préparation, acquisition, contrôle qualité, sécurité et traçabilité. Modèles de fiches, communication des résultats critiques selon les responsabilités professionnelles, algorithmes et arbres de décision.',
    tagline: 'Vos outils de terrain, prêts à l’emploi.',
    color: 'rgb(var(--color-module-6))',
  },
]
